module.exports = __webpack_public_path__ + "static/media/owl-modal.6f3de4d4.gif";